import { Box, Chip, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { ICreatedTemplateData } from "../../models/admin/communicationTemplates/communicatinTemplates";
import { markdownToSlate } from "../../common/CMS/MarkdownToSlate/MarkdownToSlate";
import { slateToHtml } from "../../common/CMS/SlateToHtml/SlateToHtml";
import CommunicationTemplatesStyles from "./CommunicationTemplatesStyles";

interface IViewTemplate {
  template: ICreatedTemplateData;
}

const ViewTemplate: FC<IViewTemplate> = ({ template }) => {
  const markdownToHTML = (content: any) => {
    let slateContent = markdownToSlate(content);
    let htmlContent = slateToHtml(slateContent as any);
    return htmlContent;
  };
  return (
    <Box 
      sx={{ padding: "1rem" }}
      id="view_template_container"
      data-test-id="view_template_container"
      aria-label="View Template"
    >
      <Box 
        sx={{ marginBottom: "1rem" }}
        id="template_header"
        data-test-id="template_header"
        aria-label="Template Header"
      >
        <Typography 
          variant="h6"
          id="template_name"
          data-test-id="template_name"
          aria-label={`Template Name: ${template.templateName}`}
        >
          {template.templateName}
        </Typography>
      </Box>
      <Box sx={CommunicationTemplatesStyles.fieldBoxContainer}>
        <Typography fontWeight="600">Subject</Typography>
        <Typography sx={CommunicationTemplatesStyles.templateCardTitle}>
          {template?.subjectLine}
        </Typography>
      </Box>
      <Box sx={CommunicationTemplatesStyles.fieldBoxContainer}>
        <Typography fontWeight="600">Body</Typography>
        <Box
          sx={{
            ...CommunicationTemplatesStyles.templateCardTitle,
            border: "1px solid #E2E8F0",
            borderRadius: "4px",
            padding: "1rem",
            width: "100%",
            maxHeight: "400px",
            overflowY: "scroll",
            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#888",
              borderRadius: "4px",
              "&:hover": {
                background: "#666",
              },
            },
          }}
          dangerouslySetInnerHTML={{
            __html: String(markdownToHTML(template?.bodyContent) || ""),
          }}
        />
      </Box>
      <Box sx={CommunicationTemplatesStyles.fieldBoxContainer}>
        <Typography fontWeight="600">Placeholders</Typography>
        <Stack
          direction="row"
          spacing={1}
          flexWrap="wrap"
          sx={{ marginTop: 1, gap: 1 }}
        >
          {template?.placeholders.map((value) => (
            <Chip
              size="small"
              key={value}
              label={value.includes("{{") ? value : `{{${value}}}`}
            />
          ))}
        </Stack>
      </Box>
    </Box>
  );
};

export default ViewTemplate;
